<template>
  <div>
    <loader :loading="loading"/>
    <panel v-if="!loading" :title="title">
      <div slot="header-right" v-if="!product.variationsCombination">
        <button class="btn btn--sm btn--info btn-history" @click="showPriceHistory(product.variations[0].sku)">
          <i class="icon-folder-search"></i>
          <span>Histórico de alteração de preços</span>
        </button>
      </div>

      <variation-type-multi
        :productId="product.productId"
        v-if="product.variationsCombination"
        v-for="variation in product.variations"
        :variation="variation"
        :sourceVariation="getSourceVariation(variation)"
        :category="category"
        :key="variation"
        :fromModule="product.source"
        :product="product"
      />

      <variation-type-single
        :productId="product.productId"
        v-if="!product.variationsCombination"
        :variation="product.variations[0]"
        :sourceVariation="getSourceVariation(product.variations[0])"
        :category="category"
        :fromModule="product.source"
      />
      <modal-price-history :sku="skuModal" :module="{ 'type': 'marketplace', 'identifier': 'mercadoLivre' }" v-model="modalPriceHistory" :code="product.code"/>
    </panel>
  </div>
</template>

<script>
  import { isArray } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import VariationTypeSingle from '@/components/marketplace/mercadoLivre/announcement/edit/variation/Single'
  import VariationTypeMulti from '@/components/marketplace/mercadoLivre/announcement/edit/variation/Multi'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'
  import ModalPriceHistory from '@/components/marketplace/shared/ModalPriceHistory'

  export default {
    data: () => ({
      loading: true,
      variationsCombination: null,
      variationsNotFoundOnSource: false,
      modalPriceHistory: false,
      skuModal: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      sourceProduct: {
        type: Object,
        required: true
      },
      sizes: {
        type: Array,
        required: false
      },
      category: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.loading = true
      const variationsCombination = this.product.variationsCombination !== null ? this.product.variationsCombination.split('+') : []
      for (let i in this.category.variations_attributes) {
        const categoryAttribute = this.category.variations_attributes[i]
        categoryAttribute.required = variationsCombination.indexOf(categoryAttribute.id) !== -1
      }

      for (let i in Object.keys(this.product.variations)) {
        const variation = this.product.variations[i]
        const variationAttributes = Object.assign(variation.attributes)
        variation.attributes = []

        const sourceVariation = this.getSourceVariation(variation)

        if (sourceVariation === undefined) {
          this.variationsNotFoundOnSource = true
          break
        }

        for (let i in this.category.variations_attributes) {
          const categoryAttribute = this.category.variations_attributes[i]

          let attribute = variation.attributes[categoryAttribute.id]

          if (attribute !== undefined) {
            continue
          }

          let attributeValue = null

          const variationAttribute = variationAttributes.find(attribute => attribute.id === categoryAttribute.id)

          if (variationAttribute !== undefined) {
            if (categoryAttribute.id === 'COLOR' || categoryAttribute.id === 'SIZE') {
              if (
                variationAttribute.value_name !== null &&
                variationAttribute.value_name !== undefined &&
                categoryAttribute.values !== undefined &&
                isArray(categoryAttribute.values) &&
                categoryAttribute.values.find(value => value.id.toLowerCase() === variationAttribute.value_name.toLowerCase() ||
                  value.name.toLowerCase() === variationAttribute.value_name.toLowerCase()) === undefined
              ) {
                let custom = true
                if (categoryAttribute.id === 'SIZE' && this.sizes !== undefined && this.sizes.length > 0) {
                  custom = false
                }
                categoryAttribute.values.push({ id: variationAttribute.value_name, name: variationAttribute.value_name, custom: custom })
              }
            }

            if (categoryAttribute.id === 'SIZE') {
              if (this.sizes) {
                categoryAttribute.values = this.sizes
              }
            }

            attributeValue = categoryAttribute.values !== undefined && variationAttribute.value_id !== undefined ? variationAttribute.value_id : variationAttribute.value_name
          }

          if (attributeValue !== null) {
            if (categoryAttribute.allowed_units !== undefined) {
              for (const unit of categoryAttribute.allowed_units) {
                if (attributeValue.indexOf(` ${unit.id}`) !== -1) {
                  categoryAttribute.default_unit = unit.id
                }
              }

              const defaultUnit = categoryAttribute.default_unit

              if (defaultUnit !== undefined) {
                attributeValue = attributeValue.replace(` ${defaultUnit}`, '')
              }
            }

            variation.attributes[categoryAttribute.id] = attributeValue
            continue
          }

          switch (categoryAttribute.id) {
            case 'EAN':
              attributeValue = sourceVariation.ean || null
              break

            case 'SKU':
            case 'SELLER_SKU':
              attributeValue = sourceVariation.sku || null
              break

            case 'PACKAGE_HEIGHT':
              attributeValue = sourceVariation.height || null
              break

            case 'PACKAGE_LENGTH':
              attributeValue = sourceVariation.length || null
              break

            case 'PACKAGE_WIDTH':
              attributeValue = sourceVariation.width || null
              break

            case 'PACKAGE_WEIGHT':
              attributeValue = sourceVariation.weight || null
              break

            case 'COLOR':
            case 'SIZE':
              const categoryAttributeId = categoryAttribute.id.toLowerCase()

              if (sourceVariation.attributes[categoryAttributeId] === undefined || sourceVariation.attributes[categoryAttributeId] === null) {
                attributeValue = null
                break
              }

              if (sourceVariation.attributes[categoryAttributeId] !== null && categoryAttribute.values === undefined) {
                attributeValue = sourceVariation.attributes[categoryAttributeId]
                break
              }

              if (
                sourceVariation.attributes[categoryAttributeId] !== null &&
                categoryAttribute.values.find(value => value.id.toLowerCase() === sourceVariation.attributes[categoryAttributeId].toLowerCase() ||
                  value.name.toLowerCase() === sourceVariation.attributes[categoryAttributeId].toLowerCase()) === undefined
              ) {
                categoryAttribute.values.push({ id: sourceVariation.attributes[categoryAttributeId], name: sourceVariation.attributes[categoryAttributeId], custom: true })
              }

              const categoryAttributeValue = categoryAttribute.values.find(value => value.id.toLowerCase() === sourceVariation.attributes[categoryAttributeId].toLowerCase() || value.name.toLowerCase() === sourceVariation.attributes[categoryAttributeId].toLowerCase())

              attributeValue = null
              if (categoryAttributeValue !== undefined) {
                attributeValue = categoryAttributeValue.id
              }
              break
          }
          variation.attributes[categoryAttribute.id] = attributeValue
        }
      }

      if (this.variationsNotFoundOnSource) {
        notifier.error(`O produto de agrupador ${this.product.productId} possui variações da fonte faltando neste anúncio. Remova o vínculo e remigre o anúncio.`, 'Erro')
        return this.$router.push('/marketplace/mercadoLivre/announcements')
      }

      this.loading = false
    },
    computed: {
      title () {
        return this.product.variationsCombination ? 'Variações' : 'Variação'
      }
    },
    methods: {
      getSourceVariation (variation) {
        return this.sourceProduct.variations.find(sourceVariation => sourceVariation.sku === variation.sku)
      },
      showPriceHistory (sku) {
        this.skuModal = sku
        this.modalPriceHistory = true
      }
    },
    components: {
      Panel,
      VariationTypeSingle,
      VariationTypeMulti,
      FormGroup,
      Loader,
      ModalPriceHistory
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Variation.vue?e646a00e